// Logs when the client route changes
/* eslint-disable-next-line */
export const onRouteUpdate = () => {
  if (typeof window !== "undefined") {
    // track page view
  }
};
